import React from "react";
import ReactGA from "react-ga";

import facebookIcon from "./../../images/facebook.svg";
import flickrIcon from "./../../images/flickr.svg";
import bloggerIcon from "./../../images/blogger.svg";
import px500Icon from "./../../images/500px.svg";
import instagramIcon from "./../../images/instagram.svg";

import "./../../css/footer.css";

export class FooterComponent extends React.Component {

    constructor(props) {
        super(props);
        this.disableContextMenu = this.disableContextMenu.bind(this);
    }

    disableContextMenu(event) {
        event.preventDefault();
    }

    render() {
        return (
            <section id="footer-component">
                <div className="content-box" onContextMenu={this.disableContextMenu}>
                    <ReactGA.OutboundLink eventLabel="footer-facebook-link" to="https://www.facebook.com/wilsonngphotography/" target="_blank">
                        <img src={facebookIcon} alt="" />
                    </ReactGA.OutboundLink>
                    <ReactGA.OutboundLink eventLabel="footer-blog-link" to="http://wilsonngphotography.blogspot.com/" target="_blank">
                        <img src={bloggerIcon} alt="" />
                    </ReactGA.OutboundLink>
                    <ReactGA.OutboundLink eventLabel="footer-flickr-link" to="https://www.flickr.com/photos/wilson_ng/" target="_blank">
                        <img src={flickrIcon} alt="" />
                    </ReactGA.OutboundLink>
                    <ReactGA.OutboundLink eventLabel="footer-instagram-link" to="https://www.instagram.com/wilsng/" target="_blank">
                        <img src={instagramIcon} alt="" />
                    </ReactGA.OutboundLink>
                    <ReactGA.OutboundLink eventLabel="footer-500px-link" to="https://500px.com/wilson_ng" target="_blank">
                        <img src={px500Icon} alt="" />
                    </ReactGA.OutboundLink>
                </div>
                <div className="copyright">
                    <i>Content Copyright &copy; Wilson Ng Photography.&nbsp;All Rights Reserved.<br />Website by Wilson Ng.</i>
                </div>
            </section>
        );
    }

}



// WEBPACK FOOTER //
// ./src/widgets/Common/FooterComponent.js